import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const ZIPCodeInput = React.forwardRef(function ZIPCodeInput(props, ref) {
  const { onChange, ...rest } = props;

  return (
    <NumberFormat
      {...rest}
      getInputRef={ref}
      displayType={'input'}
      type={'text'}
      format="#####"
      placeholder="#####"
      mask="_"
      allowNegative={false}
      allowLeadingZeros={true}
      isNumericString={true}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
    />
  );
});

export default ZIPCodeInput;

ZIPCodeInput.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
};
